import { b64DecodeUnicode } from '../../utils/base64-utils';
import { initDatalayerElement } from '../tracking/datalayer';

const LOCAL_NAV_SECONDARY_CLASSNAME = '.c-local-nav__secondary';
const LOCAL_NAV_BOTTOM_CLASSNAME = '.c-local-nav__bottom';
const BOTTOM_WRAPPER_CLASSNAME = 'c-local-nav__bottom-wrapper';
const BOTTOM_WRAPPER_TITLE_CLASSNAME = 'c-local-nav__item-section';
const BOTTOM_WRAPPER_LIST_CLASSNAME = 'c-local-nav__list';
const BOTTOM_WRAPPER_ITEM_CLASSNAME = 'c-local-nav__list-item';
const BOTTOM_WRAPPER_ITEM_IMAGE_CONTAINER_CLASSNAME = 'c-local-nav__image-container';

const $secondaryNav = document.querySelector(LOCAL_NAV_SECONDARY_CLASSNAME);
const $bottomNav = document.querySelector(LOCAL_NAV_BOTTOM_CLASSNAME);

const renderAnchor = (item) => {
  const $anchor = document.createElement('a');

  if (item?.anchorHref) {
    $anchor.href = item.anchorHref;
  }
  if (item?.anchorRel) {
    $anchor.rel = item.anchorRel;
  }
  if (item?.anchorText) {
    $anchor.textContent = item.anchorText;
  }
  if (item?.anchorClassNames) {
    $anchor.className = item.anchorClassNames;
  }
  if (item?.anchorId) {
    $anchor.id = item.anchorId;
  }
  if (item?.anchorTarget) {
    $anchor.target = item.anchorTarget;
  }

  if (item?.anchorZoneId) {
    $anchor.setAttribute('data-zoneid', item.anchorZoneId);
  }

  if (item?.anchorZoneIdQp) {
    $anchor.setAttribute('data-zoneid-qp', item.anchorZoneIdQp);
  }

  if (item.icon) {
    const $icon = document.createElement('i');
    $icon.className = item.icon.classNames;
    $icon.setAttribute('data-innerHtml', b64DecodeUnicode(item.icon.svg));
    $anchor.appendChild($icon);
  }

  if (item.image) {
    const $imageContainer = document.createElement('div');
    $imageContainer.className = BOTTOM_WRAPPER_ITEM_IMAGE_CONTAINER_CLASSNAME;
    const $image = document.createElement('img');
    $image.setAttribute('data-src', item.image.urlImage);
    $imageContainer.appendChild($image);
    $anchor.prepend($imageContainer);
  }

  return $anchor;
};

export const lazyLoadBottomNavAssets = () => {
  // Find all images with dataSrc attribute and convert to src
  const images = document.querySelectorAll('img[data-src]');
  images.forEach((image) => {
    image.src = image.dataSrc;
    image.setAttribute('src', image.getAttribute('data-src'));
    image.removeAttribute('data-src');
  });

  // Find all icons with dataInnerHTML attribute and convert to innerHTML
  const icons = document.querySelectorAll('i[data-innerHtml]');
  icons.forEach((icon) => {
    icon.innerHTML = icon.getAttribute('data-innerHtml');
    icon.removeAttribute('data-innerHtml');
  });
};

const renderSecondary = (secondary) => {
  secondary?.forEach((item) => {
    const $anchor = renderAnchor(item);
    $secondaryNav.appendChild($anchor);
  });

  return $secondaryNav;
};

const renderItem = (item, parent) => {
  const $listItem = document.createElement('li');
  $listItem.className = item?.listItemClassNames || BOTTOM_WRAPPER_ITEM_CLASSNAME;
  const $anchor = renderAnchor(item);

  $listItem.appendChild($anchor);
  parent.appendChild($listItem);
  return $listItem;
};

const renderSections = (sections) => {
  sections.forEach((section) => {
    const $sectionWrapper = document.createElement('div');
    $sectionWrapper.className = BOTTOM_WRAPPER_CLASSNAME;

    if (section.title) {
      const $titleSpan = document.createElement('span');
      $titleSpan.className = BOTTOM_WRAPPER_TITLE_CLASSNAME;
      $titleSpan.textContent = section.title;
      $sectionWrapper.appendChild($titleSpan);
    }

    const $navList = document.createElement('ul');
    $navList.className = section?.listClassNames || BOTTOM_WRAPPER_LIST_CLASSNAME;

    section.items.forEach((item) => {
      renderItem(item, $navList);
    });

    $sectionWrapper.appendChild($navList);
    $bottomNav.appendChild($sectionWrapper);
  });

  return $bottomNav;
};

export const renderLocalNavigation = ({ secondary, sections }) => {
  if (secondary) {
    renderSecondary(secondary);
    initDatalayerElement($secondaryNav);
  }
  if (sections) {
    renderSections(sections);
    initDatalayerElement($bottomNav);
  }
};
